// Image preview plugin. See ../README.md for the plugin API.
import ImagePreview from './ImagePreview.vue'

const IMAGE_EXTENSIONS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.webp',
  '.svg',
  '.bmp',
  '.tiff',
  '.ico',
]

export default {
  id: 'image',
  label: 'Image',
  component: ImagePreview,

  // The peek is raw bytes, so there is nothing sensible to show in the
  // host's raw <pre>; the host hides the Rendered / Raw toggle.
  supportsRaw: false,

  // Binary peek — the host fetches it with `getBlobJson`, so `content`
  // is a Blob rather than text or JSON. The peek endpoint already serves
  // image files as raw bytes with their Content-Type, whole rather than
  // truncated, so there are no `peekParams` to set (the server ignores
  // `n` on the image branch).
  peekResponseType: 'blob',

  matches({ file }) {
    // Name-only check, so the answer is identical on the pre-fetch pass
    // (content: null) and the post-fetch pass, as the contract asks.
    const name = file.name.toLowerCase()
    return IMAGE_EXTENSIONS.some((ext) => name.endsWith(ext))
  },
}
